import React, { } from 'react';

import { NavLink } from 'react-router-dom'
import { WhatsAppModel } from './models/WhatsAppModel';
// import useWebSocket, { ReadyState } from "react-use-websocket"

import './_Menu.css'
import CheckLoggedUser from './login/checkLoggedUser';
import { LoginModel } from './models/LoginModel';
import WebsocketMessages from './whatsup/WebsocketMessages';
import { CustomerCardModel } from './models/CustomerCardModel';
import { ProductionModel } from './models/ProductionModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';


type Props = {
    activePage: string
};
type State = {
    menuPermissions: any[],
    menuItems: any[],
    loggedUser: any,
    enableLoginCheck: boolean;
    whatsappNewMessages: number;
    signingNewMessages: number;
    // NEW: mobile menu open/close
    isMobileMenuOpen: boolean;
};

export class Menu extends React.Component<Props, State> {
    loginModel: LoginModel = new LoginModel();
    state: State = {
        menuPermissions: [],
        menuItems: [],
        loggedUser: null,
        whatsappNewMessages: 0,
        signingNewMessages: 0,
        enableLoginCheck: false,
        // NEW: default closed on mobile
        isMobileMenuOpen: false
    }
    constructor(props: any) {
        super(props);
        this.getWhatsappMessagesCounter = this.getWhatsappMessagesCounter.bind(this);
        this.onNewMessageArrived = this.onNewMessageArrived.bind(this);
        this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
        this.closeMobileMenu = this.closeMobileMenu.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    // NEW: toggle mobile menu
    toggleMobileMenu() {
        this.setState((prev) => ({
            isMobileMenuOpen: !prev.isMobileMenuOpen
        }));
    }

    // NEW: helper to close menu (e.g. after clicking a link)
    closeMobileMenu() {
        this.setState({ isMobileMenuOpen: false });
    }

    // updateMessages() {
    //     
    //     this.getWhatsappMessagesCounter();
    // }

    async load() {
        const userDataStr = localStorage.getItem('loggedUser');
        const userData = userDataStr ? JSON.parse(userDataStr) : {}
        const menuPermissions = userData.menuPermissions;
        let userId = '';
        console.log('menuPermissions', menuPermissions);
        const parsedData = localStorage.getItem('loggedUser');
        if (parsedData) {
            const loggedUser = JSON.parse(parsedData)
            userId = loggedUser.id;
            this.setState({
                loggedUser
            });
        }

        const menuItems: any[] = [

            {
                id: 1,
                label: 'בית',
                code: 'Home',
                // link:'/',
                // httpLink: `https://dev.superbit.co.il/Account/LoginToPage?userId=${userId}&page=/Home`,
                httpLink: `https://old.superbit.co.il/Account/LoginToPage?userId=${userId}&page=/Home`,
                cssClass: 'home',
                approved: false,
                messages: 0
            },
            {
                id: 2,
                label: 'אימייל',
                code: 'Email',
                link: '/Emails',
                cssClass: 'email',
                approved: false,
                messages: 0
            },
            {
                id: 3,
                label: 'וואטס אפ',
                code: 'Whatsapp',
                link: '/Whatsapp',
                cssClass: 'whatsapp',
                approved: false,
                new: this.state.whatsappNewMessages,
                messages: 0
            },
            {
                id: 3,
                label: 'לידים',
                code: 'Leads',
                link: '/Leads',
                cssClass: 'leads',
                approved: false,
                messages: 0
            },
            {
                id: 4,
                label: 'סימולטור',
                code: 'Simulator',
                link: '/Simulator',
                cssClass: 'simulator',
                approved: false,
                messages: 0
            },
            {
                id: 5,
                label: 'מנויים',
                code: 'Riders',
                link: '/Subscribers',
                cssClass: 'subscribers',
                approved: false,
                messages: 0
                //httpLink: `https://dev.superbit.co.il/Account/LoginToPage?userId=${userId}&page=/rider`,
                // httpLink: `https://devprod.superbit.co.il/Account/LoginToPage?userId=${userId}&page=/rider`,
            },
            {
                id: 6,
                label: 'ניהול לקוחות',
                code: 'CustomerManagement',
                link: '/Clients',
                cssClass: 'clients',
                approved: false
            },
            {
                id: 7,
                label: 'משימות',
                code: 'Tasks',
                link: '/Tasks',
                cssClass: 'tasks',
                approved: false,
            },
            {
                id: 8,
                label: 'תביעות',
                code: 'Claims',
                link: '/Sues',
                cssClass: 'claims',
                approved: false,
                messages: 0
            },
            {
                id: 9,
                label: 'דוחות',
                code: 'ReportGenerator',
                cssClass: 'reports',
                approved: false,
                messages: 0
            },
            {
                id: 10,
                label: 'חידושים',
                code: 'Renewals',
                link: '/Renewals',
                cssClass: 'renewals',
                approved: false,
                messages: 0
            },
            {
                id: 11,
                label: 'חיתומים',
                code: 'Signing',
                link: '/Signing',
                cssClass: 'signatures',
                approved: false,
                messages: this.state.signingNewMessages
            }
            ,
            {
                id: 12,
                label: 'ניהול מערכת',
                code: 'SystemManagement',
                link: '/SystemManagement',
                cssClass: 'SystemManagement',
                approved: false,
                messages: 0
            }
        ];
        if (menuPermissions) {
            menuPermissions.filter((x: any) => x.permissionType >= 0).forEach((mp: any) => {
                const menuItem = menuItems.find((m: any) => m.code == mp.moduleName);
                if (menuItem ) {
                    menuItem.approved = true;
                }
            });
            this.setState({
                menuPermissions,
                menuItems
            });
        }

        await this.getWhatsappMessagesCounter();
        await this.getNewTaskCounter();
        await this.getNewSigningCounter();
        // console.log('menuItems', menuItems);
    }

    async onNewMessageArrived(messageType: string, message: any) {
        switch (messageType) {
            case 'Whatsapp':
                await this.getWhatsappMessagesCounter(message);
                break;
            case 'Tasks':
                await this.getNewTaskCounter(message);
                break;
            case 'Signings':
                await this.getNewSigningCounter();
                break;

            default:
                break;
        }
    }

    async getWhatsappMessagesCounter(message?: any) {
        var whatsallMessages = (await new WhatsAppModel().WhatsappGetNewMessages());
        if (whatsallMessages.statusCode == 200) {
            var newMessages = parseInt(whatsallMessages.statusMessage);
            await this.setState({
                whatsappNewMessages: newMessages
            });
            const menuItems = this.state.menuItems;
            const whatsappMenuItemIndex = menuItems.findIndex((i: any) => i.code == 'Whatsapp');
            if (whatsappMenuItemIndex >= 0) {
                menuItems[whatsappMenuItemIndex].messages = newMessages
            }

            this.setState({
                menuItems
            });
        } else {
            localStorage.removeItem('loggedUser');
            this.loginModel.logOut();
            this.setState({
                enableLoginCheck: true
            })
        }

    };

    async getNewTaskCounter(message?: any) {
        var newTasks = await new CustomerCardModel().getNewAssignments(this.state.loggedUser.id);
        console.log('newTasks', newTasks);
        const menuItems = this.state.menuItems;
        const tasksMenuItemIndex = menuItems.findIndex((i: any) => i.code == 'Tasks');
        if (tasksMenuItemIndex >= 0) {
            menuItems[tasksMenuItemIndex].messages = newTasks
        }

        this.setState({
            menuItems
        });
    }

    async getNewSigningCounter() {
        var newSignings = await new ProductionModel().GetSigningCounter();
        console.log('newSignings', newSignings);

        const menuItems = this.state.menuItems;
        const tasksMenuItemIndex = menuItems.findIndex((i: any) => i.code == 'Signing');
        if (tasksMenuItemIndex >= 0) {
            menuItems[tasksMenuItemIndex].messages = newSignings
        }

        this.setState({
            menuItems
        });


        this.setState({
            signingNewMessages: newSignings
        });
    }

    render() {
        const menuPermissions = this.state.menuPermissions;
        return (<div>
            <WebsocketMessages updateMessages={this.onNewMessageArrived} ></WebsocketMessages>
            <section className="side-menu-container">
                {/* MOBILE TOGGLE BUTTON (hidden on desktop by CSS) */}
                <button
                    type="button"
                    className="menu-toggle"
                    onClick={this.toggleMobileMenu}
                    aria-label={this.state.isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                >
                    <FontAwesomeIcon icon={this.state.isMobileMenuOpen ? faTimes : faBars} />
                </button>


                <div className="logo-holder flex-centered flex-justify-center">
                    <div className="logo"></div>
                </div>
                <div className={`side-menu ${this.state.isMobileMenuOpen ? 'open' : ''}`}>
                    {
                        this.state.menuItems.map((menuItem: any, index: number) => {
                            if (!menuItem.approved) {
                                return null;
                            }

                            return (
                                <div className={`menu-item ${menuItem.cssClass} flex-centered ${this.props.activePage == menuItem.code ? 'selected' : ''}`}
                                    key={index}
                                    onClick={this.closeMobileMenu} // close menu when any item clicked (on mobile)
                                >
                                    {menuItem.link ? (<>


                                        <NavLink className={({ isActive }) =>

                                            (isActive ? "menu-item-link flex-centered selected" : "menu-item-link flex-centered")} to={menuItem.link}>
                                            <div className="icon"></div>
                                            <div className="title">
                                                {menuItem.label}
                                                <div className={menuItem.messages > 0 ? "newMessages" : "hide"}>{menuItem.messages}</div>
                                            </div>
                                        </NavLink>
                                    </>)
                                        :
                                        (<>
                                            {menuItem.httpLink ? (
                                                <>
                                                    <div className="icon"></div>
                                                    <div className="title">
                                                        <a href={menuItem.httpLink} target='_blank' rel="noreferrer">
                                                            {menuItem.label}
                                                        </a>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="icon"></div>
                                                    <div className="title">
                                                        {menuItem.label}
                                                    </div>
                                                </>
                                            )}

                                        </>)}
                                </div>
                            )


                        })
                    }

                </div>
                {/* {history.state && history.state.enableLoginCheck && <CheckLoggedUser></CheckLoggedUser>} */}
            </section>
        </div>



        );
    }
}
